// Type for YAML-based affiliate banners (ComponentAffiliateBannerYaml)
export interface YamlAffiliateBanner {
  id: string;
  yamlId?: string;
  title?: string;
  name?: string; // For backward compatibility
  url?: string;
  code?: string | { code?: string }; // Handle both direct string and nested object
  image?: any;
  alt?: string;
}

export default class AffiliateBanner {
  id: string;
  name: string;
  url: string;
  code?: string;
  image?: any;

  constructor(banner: YamlAffiliateBanner) {
    this.id = banner.id;
    // Handle both new YAML structure (title) and old Contentful structure (name)
    this.name = banner.title || banner.name || "";
    this.url = banner.url || "";

    // Handle both direct string code and nested object code
    if (banner.code) {
      if (typeof banner.code === "string") {
        this.code = banner.code;
      } else if (banner.code.code) {
        this.code = banner.code.code;
      }
    }

    if (banner.image) {
      this.image = banner.image as any;
    }
  }
}
